









import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import { Prop, Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    IconUserImage
  }
})
export default class TheJPointDestination extends Vue {
  @Prop({ type: String, required: true }) icon!: string;
  @Prop({ type: String, required: true }) userName!: string;
}
